import { createSlice } from '@reduxjs/toolkit'
import dayjs from 'dayjs'

import { getFilteredList, getRegexSafeString } from '@/util/misc'
import { getShopOrderStatusTextId, ECOM_STATUS } from '@/util/orders'

import { getMessage } from './i18nReducer'

export const NAME = 'shop-orders'

const initialState = {
  orders: [],
  textFilter: '',
  statusFilter: ECOM_STATUS.OPEN,
}

const { actions, reducer } = createSlice({
  name: NAME,
  initialState,
  reducers: {
    setOrders: (state, { payload: orders }) => {
      state.orders = orders
    },
    setTextFilter: (state, { payload: textFilter }) => {
      state.textFilter = textFilter
    },
    setStatusFilter: (state, { payload: statusFilter }) => {
      state.statusFilter = statusFilter
    },
    reset: () => ({
      ...initialState,
    }),
  },
})

export const { setOrders, setTextFilter, setStatusFilter, reset } = actions

export default reducer
// @ts-ignore
const getState = state => state[NAME]
// @ts-ignore
export const getOrders = state =>
  // @ts-ignore
  getState(state)?.orders?.map(order => ({
    ...order,
    statusText: getMessage(state, getShopOrderStatusTextId(order.status)),
  })) || []
// @ts-ignore
export const getTextFilter = state => getState(state).textFilter
// @ts-ignore
export const getStatusFilter = state => getState(state).statusFilter
// @ts-ignore
export const getFilteredOrders = state =>
  getFilteredList(state, getOrders, textFilter, statusFilter)
// @ts-ignore
export const getNumberOfOrders = state => getFilteredOrders(state).length

// todo: remove when refactored
// @ts-ignore
const parseIsoDate = date => date && new Date(fixISOStringForIE(date))
// @ts-ignore
const fixISOStringForIE = dateString => {
  const hasTime = dateString.includes('T')
  if (!hasTime) return dateString

  // til "1984-02-25T00:00:00+00:00" format from "1984-02-25T00:00:00+0000"
  return `${dateString.substring(0, dateString.length - 2)}:${dateString.substring(
    dateString.length - 2,
    dateString.length
  )}`
}
// @ts-ignore
const getNorwegianDateFormat = date => {
  if (!date) return null
  let year = date.getFullYear()
  let month = date.getMonth() + 1
  let day = date.getDate()
  if (month < 10) month = '0' + month
  if (day < 10) day = '0' + day
  return `${day}.${month}.${year}`
}

// todo: add proper date formatting
// @ts-ignore
const textFilter = (state, orders) => {
  const textFilter = getTextFilter(state)
  if (!textFilter) return orders

  const keyWords = getRegexSafeString(textFilter).split(' ')
  // @ts-ignore
  return orders.filter(order =>
    // @ts-ignore
    keyWords.every(keyWord => {
      const regExp = new RegExp(keyWord, 'i')
      const deliveryDate = order.delivery_date
        ? getNorwegianDateFormat(parseIsoDate(order.delivery_date))
        : ''
      const orderDate = order.order_date
        ? getNorwegianDateFormat(parseIsoDate(order.order_date))
        : ''
      const statusText = getMessage(state, getShopOrderStatusTextId(order.status))

      return `${order.id}${order.users}${order.codes}${statusText}${order.customer_name}${order.org_no}${order.vendor_sales_order_no}${deliveryDate}${orderDate}`.match(
        regExp
      )
    })
  )
}
// @ts-ignore
export const getCsvExportData = state =>
  getFilteredOrders(state).map(order => ({
    id: order.id,
    'vendor internal sales number': order.vendor_sales_order_no || '',
    customer: order.customer_name,
    users: order.users,
    'phone numbers': order.codes,
    status: order.statusText,
    'down payments': order.remainder_amount === 0 ? 0 : order.down_payments,
    'payment size': order.remainder_amount === 0 ? 0 : order.remainder_amount / order.down_payments,
    cost: order.cost,
    'remainder amount': order.remainder_amount,
    'order date': order.order_date ? dayjs(order.order_date).format('YYYY-MM-DD HH:mm') : '',
    'approval date': order.approved_at ? dayjs(order.approved_at).format('YYYY-MM-DD HH:mm') : '',
    'delivery date':
      order.delivery_date || order.estimated_delivery
        ? dayjs(order.delivery_date || order.estimated_delivery).format('YYYY-MM-DD HH:mm')
        : '',
  }))
// @ts-ignore
const statusFilter = (state, orders) => {
  const statusFilter = getStatusFilter(state)

  return statusFilter !== ECOM_STATUS.ALL
    ? orders.filter(
        // @ts-ignore
        order =>
          order.status === statusFilter ||
          (statusFilter === ECOM_STATUS.OPEN && orderIsOpen(order.status))
      )
    : orders
}
// @ts-ignore
const orderIsOpen = status =>
  [ECOM_STATUS.NEW, ECOM_STATUS.ACCEPTED, ECOM_STATUS.CONFIRMED].includes(status)
// @ts-ignore
export const getStatusCounter = state =>
  getOrders(state).reduce(
    // @ts-ignore
    (acc, cur) => {
      acc[ECOM_STATUS.ALL]++
      acc[ECOM_STATUS.OPEN] += orderIsOpen(cur.status) ? 1 : 0
      acc[cur.status] = acc[cur.status] ? acc[cur.status] + 1 : 1

      return acc
    },
    {
      [ECOM_STATUS.ALL]: 0,
      [ECOM_STATUS.OPEN]: 0,
    }
  )
